/**
 * Invalidation that respects the keep-alive tabs (UI overhaul PR-2).
 *
 * After a write (a staged edit, a goal saved, a negative applied) the cached
 * answers under a key prefix are stale in EVERY operator scope. TanStack's
 * default `invalidateQueries` would also refetch each stale query that still
 * has an observer — and a hidden keep-alive pane keeps its observers, so a
 * save on Search Terms would fire the hidden Targets pane's two 50k-row
 * reads for nobody. This helper marks everything stale without fetching;
 * the caller refetches the queries on its own screen, and a hidden pane
 * catches up when it comes back (`useApiQuery`'s return effect) or on its
 * next mount.
 */
import type { QueryClient, QueryKey } from '@tanstack/react-query'
import { scopedKeyMatches } from './keys'

export function invalidatePrefix(client: QueryClient, prefix: QueryKey): Promise<void> {
  return client.invalidateQueries({
    predicate: (q) => scopedKeyMatches(q.queryKey, prefix),
    refetchType: 'none',
  })
}
